import React from "react";
import { Box, Stack } from "@mui/material";
import Body2 from "../typography/body-02";
import Body3 from "../typography/body-03";
import { formatCurrency } from "../../utils/format-currency";
import styles from "./index.module.scss";

// "Your registered program & pricing" summary — mirrors the CLEARpath
// prototype's regSummaryCard()/reg-card, shown at the top of AURA Panel D and
// on the non-AURA "Program registered" confirmation. `program` is whatever was
// dispatched via setSelectedProgram (raw eligible-product row shape: name,
// rate, price, lockPeriod, totalPayment — see EligibleProductRow).
const RegisteredProgramCard = ({ program, title = "Your registered program & pricing" }) => (
	<Box className={styles.regCard}>
		<Body2 text={title} fontType="semibold" extraClass={styles.regHeading} />
		<Box className={styles.regGrid}>
			<Stack direction="column" gap={0.5}>
				<Body3 text="Loan program" extraClass={styles.subTitle} />
				<Body2 text={program?.name || "—"} fontType="semibold" />
			</Stack>
			<Stack direction="column" gap={0.5}>
				<Body3 text="Rate" extraClass={styles.subTitle} />
				<Body2
					text={program?.rate != null ? `${Number(program.rate).toFixed(3)}%` : "—"}
					fontType="semibold"
				/>
			</Stack>
			<Stack direction="column" gap={0.5}>
				<Body3 text="Price" extraClass={styles.subTitle} />
				<Body2
					text={program?.price != null ? Number(program.price).toFixed(3) : "—"}
					fontType="semibold"
				/>
			</Stack>
			<Stack direction="column" gap={0.5}>
				<Body3 text="Lock period" extraClass={styles.subTitle} />
				<Body2 text={program?.lockPeriod ? `${program.lockPeriod} days` : "—"} fontType="semibold" />
			</Stack>
		</Box>
		{program?.totalPayment != null && (
			<Body3
				text={`Estimated payment: ${formatCurrency.format(Number(program.totalPayment) || 0)}/mo`}
				extraClass={styles.paymentNote}
			/>
		)}
	</Box>
);

export default RegisteredProgramCard;
